import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

const FaqOne = (props) => {
  const { itemClass, items, hasPreExpanded } = props;
  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'it-custom-accordion it-custom-accordion-style-3 inner-style'
      }
    >
      <Accordion
        className="accordion"
        preExpanded={hasPreExpanded ? ['a'] : ''}
        allowZeroExpanded
      >
        {items?.map((item) => (
          <AccordionItem
            key={item.id}
            className="accordion-items"
            uuid={item.id}
          >
            <AccordionItemHeading className="accordion-header">
              <AccordionItemButton className="accordion-buttons">
                <i>{item.itemCount}.</i> {item.btnText}
              </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
              <div className="accordion-body d-flex align-items-center">
                <p className="mb-0">{item.description}</p>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FaqOne;
